import PrivacyReps from '@/components/PrivacyReps'
const routes = [{ path: 'reps', component: PrivacyReps }]

export default routes
